import React, { useEffect, useState } from 'react';
import { Box, Button, Modal, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { myContainerStyle } from '../../../configs/ui/constant';
import MaterialTable from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import Axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { faFileDownload, faSpinner } from '@fortawesome/pro-duotone-svg-icons';
import { useSnackbar } from 'notistack';
import { endOfDay } from 'date-fns';
import { th } from 'date-fns/locale';
import 'react-nice-dates/build/style.css';
import { useDateInput } from 'react-nice-dates';
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import CreateReportCollectPoint from '../../../components/Modal/Report/CreateReportCollectPoint';
import FileSaver from 'file-saver';

const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   paper: {
      // display: 'flex',
      border: `1px solid ${theme.palette.divider}`,
      flexWrap: 'wrap',
   },
}));

const columnsA = [
   {
      field: 'reportName',
      title: 'ชื่อรายงาน',
   },
   {
      field: 'reportDetail',
      title: 'รายละเอียด',
   },
   {
      field: 'creator',
      title: 'ผู้ขอรายงาน',
   },
   {
      field: 'createdTime',
      title: 'เวลาที่สร้าง',
   },
];
const ReportCollectPoint = () => {
   const history = useHistory();
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const [resp, setResp] = useState([]);
   const [data, setData] = useState([]);
   const [myModal, setMyModal] = useState('');
   const [showModal, setShowModal] = useState(false);

   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
      reset,
   } = useForm({
      defaultValues: {
         startDate: new Date('01/01/2020 00:00:00'),
         endDate: new Date(),
      },
   });
   const selectStartDate = watch('startDate');
   const selectEndDate = watch('endDate');
   useEffect(() => {
      register({ name: 'startDate' });
      register({ name: 'endDate' });
   }, [register]);
   const handleStartDateChange = (e) => setValue('startDate', e);
   const handleEndDateChange = (type) => (e) => {
      if (type === 'auto') setValue('endDate', endOfDay(e));
      else setValue('endDate', e);
   };
   const timeStartInputProps = useDateInput({
      date: getValues('startDate'),
      format: 'HH:mm',
      locale: th,
      onDateChange: handleStartDateChange,
   });
   const timeEndInputProps = useDateInput({
      date: getValues('endDate'),
      format: 'HH:mm',
      locale: th,
      onDateChange: handleEndDateChange('manual'),
   });
   useEffect(() => {
      getData(null);
   }, []);
   useEffect(() => {
      setTableData();
   }, [resp]);
   const getData = (value) => {
      setIsLoading(true);
      Axios.post('/GSB/dashboard/report/GetReportList', {
         reportType: 3,
      })
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               const statusCode = e.response.status;
               if (statusCode === 401) {
                  sessionStorage.clear();
                  localStorage.clear();
                  history.push('/');
               }
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            setIsLoading(false);
         });
   };
   const setTableData = () => {
      if (resp.length > 0) {
         const dataForMap = resp;
         const formatted = dataForMap.map((value) => {
            return Object.assign(
               {},
               {
                  ...value,
               },
            );
         });
         setIsLoading(false);
         setData(formatted);
      }
   };
   const refreshData = () => {
      setShowModal(false);
      setData([]);
      getData();
   };

   const onSubmit = (e) => {
      sessionStorage.setItem('value', JSON.stringify(e));
      if (sessionStorage['value']) {
         const values = JSON.parse(sessionStorage.getItem('value'));
         setData([]);
         getData(values);
      }
   };
   const setModalStyle = (type, value) => {
      if (type === 'create') {
         setMyModal(
            <CreateReportCollectPoint
               onClickClose={() => setShowModal(false)}
               onSuccess={() => refreshData()}
            />,
         );
      }
      setShowModal(!showModal);
   };
   const downloadReport = (rowData) => {
      if (rowData.status === 1) {
         return false;
      } else {
         Axios.get(
            `/GSB/dashboard/report/DownloadReport?reportId=${rowData.reportId}`,
            {
               responseType: 'blob',
            },
         )
            .then((response) => {
               if (response) {
                  FileSaver.saveAs(
                     new Blob([response.data]),
                     rowData.reportName,
                  );
               }
            })
            .catch((err) => {
               LogToBackend(err);
               enqueueSnackbar('เกิดข้อผิดพลาด กรุณาตรวจสอบข้อมูล', {
                  variant: 'error',
               });
            });
      }
   };
   return (
      <Paper style={myContainerStyle.root}>
         <Modal className={classes.modal} open={showModal}>
            <React.Fragment>{myModal}</React.Fragment>
         </Modal>
         <Box display='flex' my={1} alignItems='center'>
            <Box mx={1}>
               <Typography variant='h5'>รายงานการสะสมคะแนน</Typography>
            </Box>
            <Box mx={1}>
               <Button
                  variant='contained'
                  color='primary'
                  size='small'
                  startIcon={
                     <FontAwesomeIcon icon={faFileDownload} size={'xs'} />
                  }
                  onClick={() => {
                     setModalStyle('create', '');
                  }}
               >
                  ดาวน์โหลดไฟล์
               </Button>
            </Box>
         </Box>
         {/*<Box
        m={1}
        p={1}
        style={{
          background: '#f6f6f6',
          borderRadius: '10px',
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            display={'flex'}
            alignItems={'flex-start'}
            flexDirection={'column'}
            fontSize={20}
          >
            <Box width={'100%'}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <TitleLabel Fs={'14px'}>ฝ่าย/ภาค&nbsp;:&nbsp;</TitleLabel>
                </Grid>
                <Grid item xs={4}>
                  <TitleLabel Fs={'14px'}>ส่วน/เขต&nbsp;:&nbsp;</TitleLabel>
                </Grid>
                <Grid item xs={4}>
                  <TitleLabel Fs={'14px'}>
                    หน่วยงาน/สาขา&nbsp;:&nbsp;
                  </TitleLabel>
                </Grid>
                <Grid item xs={3}>
                  <TitleLabel Fs={'14px'}>ตั้งแต่&nbsp;:&nbsp;</TitleLabel>
                  <Box width={'100%'} style={{ position: 'relative' }}>
                    <DatePicker
                      date={selectStartDate}
                      onDateChange={handleStartDateChange}
                      // locale={th}
                      // format="dd MMM yyyy"
                      locale={enUS}
                    >
                      {({ inputProps, focused }) => (
                        <Box width={'100%'}>
                          <Input
                            className={'input' + (focused ? ' -focused' : '')}
                            {...inputProps}
                            value={`${
                              inputProps.value &&
                              dayjs(new Date(inputProps.value)).format(
                                'DD/MM/BBBB',
                              )
                            }`}
                            width={'51%'}
                            margin={'0px 3% 0px 0px'}
                            placeholder={'เลือกวันที่'}
                            readOnly
                          />
                          <Input
                            className="input"
                            {...timeStartInputProps}
                            width={'46%'}
                            type={'time'}
                          />
                        </Box>
                      )}
                    </DatePicker>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <TitleLabel Fs={'14px'}>จนถึง&nbsp;:&nbsp;</TitleLabel>
                  <Box width={'100%'} style={{ position: 'relative' }}>
                    <DatePicker
                      date={selectEndDate}
                      onDateChange={handleEndDateChange('auto')}
                      // locale={th}
                      // format="dd MMM yyyy"
                      minimumDate={
                        getValues('startDate')
                          ? getValues('startDate')
                          : new Date()
                      }
                      locale={enUS}
                    >
                      {({ inputProps, focused }) => (
                        <Box width={'100%'}>
                          <Input
                            className={'input' + (focused ? ' -focused' : '')}
                            {...inputProps}
                            value={`${
                              inputProps.value &&
                              dayjs(new Date(inputProps.value)).format(
                                'DD/MM/BBBB',
                              )
                            }`}
                            width={'51%'}
                            margin={'0px 3% 0px 0px'}
                            placeholder={'เลือกวันที่'}
                            readOnly
                          />
                          <Input
                            className="input"
                            {...timeEndInputProps}
                            width={'46%'}
                            type={'time'}
                          />
                        </Box>
                      )}
                    </DatePicker>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box
              mt={1}
              display={'flex'}
              justifyContent={'flex-end'}
              width={'100%'}
            >
              <Button
                variant={'contained'}
                size={'small'}
                color={'primary'}
                type={'submit'}
                startIcon={<FontAwesomeIcon icon={faFilter} size={'xs'} />}
              >
                ตัวกรอง
              </Button>
              <Button
                size={'small'}
                onClick={() => {
                  reset();
                  getData(null);
                }}
              >
                ล้าง
              </Button>
            </Box>
          </Box>
        </form>
      </Box>*/}
         <Box>
            <MaterialTable
               isLoading={isLoading}
               columns={[
                  {
                     field: 'reportName',
                     title: 'ชื่อรายงาน',
                  },
                  {
                     field: 'reportDetail',
                     title: 'รายละเอียด',
                  },
                  {
                     field: 'creator',
                     title: 'ผู้ขอรายงาน',
                  },
                  {
                     field: 'createdTime',
                     title: 'เวลาที่สร้าง',
                     render: (rowData) =>
                        dayjs(new Date(rowData.createdTime)).format(
                           'DD/MM/BBBB  HH:mm',
                        ),
                  },
               ]}
               data={data}
               options={{
                  showTitle: false,
                  headerStyle: headerStyle,
                  padding: 'dense',
                  actionsColumnIndex: -1,
                  actionsCellStyle: {
                     color: '#ccc',
                  },
                  addRowPosition: 'first',
                  pageSize: 5,
                  pageSizeOptions: [5, 10, 25, 50, 100],
               }}
               localization={{
                  header: { actions: 'ตัวจัดการ' },
               }}
               style={tableStyle}
               icons={tableIcons}
               actions={[
                  {
                     icon: React.forwardRef((props, ref) => (
                        <FontAwesomeIcon
                           ref={ref}
                           {...props}
                           icon={faRedoAlt}
                           size={'xs'}
                        />
                     )),
                     tooltip: 'Refresh Data',
                     isFreeAction: true,
                     onClick: () => refreshData(),
                  },
                  (rowData) => ({
                     icon: React.forwardRef((props, ref) => (
                        <FontAwesomeIcon
                           ref={ref}
                           {...props}
                           icon={
                              rowData.status === 1 ? faSpinner : faFileDownload
                           }
                           color='#00a2e8'
                           spin={rowData.status === 1}
                        />
                     )),
                     tooltip:
                        rowData.status === 1 ? 'กำลังประมวลผล' : 'ดาวน์โหลด',
                     onClick: (event, rowData) => downloadReport(rowData),
                  }),
               ]}
            />
         </Box>
      </Paper>
   );
};

export default ReportCollectPoint;
